import unescapedText from 'I18n/utils/unescapedText';
import { FloatingAlertStore } from 'foundations-components/transitional/components/FloatingAlertList';
import { isKnownErrorType, getAuthErrorI18nKeys } from '../components/LowLevelAuthFlowView/LowLevelAuthErrorAlert';

/**
 * Surfaces a headless auth failure. When the consumer provides an `onAuthError`
 * callback we defer to it; otherwise we show a floating alert so the failure is
 * never silent (the headless flow has no modal to render the error in).
 */
export function reportHeadlessAuthError(error, appName, onError) {
  if (onError) {
    onError(error);
    return;
  }
  const keys = isKnownErrorType(error.type) ? getAuthErrorI18nKeys(error.type) : getAuthErrorI18nKeys('AuthenticateError');

  // No fixed `id`: let the store assign a fresh one per call so a second
  // failure (rapid retry, or two concurrent headless flows) is not deduped away
  // or silently replaced.
  FloatingAlertStore.addAlert({
    type: 'danger',
    titleText: unescapedText(keys.titleKey, {
      appName
    }),
    message: keys.messageUsesAppName ? unescapedText(keys.messageKey, {
      appName
    }) : unescapedText(keys.messageKey)
  });
}